import PropTypes from 'prop-types';
import React from 'react';

import TemplateDefault from '@components/templates/default/default';
import Wishes from '@components/organisms/wishes/wishes';

const WishesPage = ({ data }) => {
  const {
    wishesApiKeys,
    wishes,
    categories,
    title,
    headline,
    introCopy,
    subline,
    evaluationIntro,
    wishesFormHint
  } = data;
  return (
    <TemplateDefault invertedHeader>
      <Wishes
        wishesApiKeys={wishesApiKeys}
        introduction={{ title, headline, introCopy, subline }}
        wishes={wishes}
        categories={categories}
        evaluationIntro={evaluationIntro}
        wishesFormHint={wishesFormHint}
      />
    </TemplateDefault>
  );
};

WishesPage.propTypes = {
  data: PropTypes.shape({
    wishesApiKeys: PropTypes.shape(),
    wishes: PropTypes.shape().isRequired,
    categories: PropTypes.shape().isRequired,
    title: PropTypes.string,
    headline: PropTypes.string,
    introCopy: PropTypes.string,
    subline: PropTypes.string,
    evaluationIntro: PropTypes.string,
    wishesFormHint: PropTypes.string
  }).isRequired
};

export default WishesPage;
